var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgSteam = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 160 160"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "id-0a",
  gradientUnits: "userSpaceOnUse",
  x1: "50%",
  x2: "50%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101c2f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1384B6"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  opacity: 0,
  d: "M91.2 59.3c0-8.3 6.8-15.1 15.1-15.1s15.1 6.8 15.1 15.1-6.8 15.1-15.1 15.1-15.1-6.7-15.1-15.1zM3.1 101.9C1.7 96.9.7 91.8.3 86.4 0 83.2 0 80.3 0 80c0-2.4.1-4.5.3-6.4C14.5 79.5 28.8 85.4 43 91.3c3.8-2.6 8.2-3.9 12.7-3.9H57l19.1-27.6v-.4c0-16.7 13.5-30.2 30.2-30.2s30.2 13.5 30.2 30.2-13.5 30.2-30.2 30.2h-.7L78.4 109v1.1c0 10.8-7.6 20.1-18.2 22.2-12.3 2.5-24.2-5.5-26.7-17.7L3.1 101.9zm83.1-42.5c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1c0-11.1-9-20.1-20.1-20.1-11.1 0-20.1 9-20.1 20.1zm-45.8 57.9c4.1 8.5 14.2 12 22.7 8 8.5-4.1 12-14.2 8-22.7-3.8-8-13.1-11.7-21.3-8.5L60 98.3c6.4 2.6 9.4 10 6.8 16.3-2.6 6.4-10 9.4-16.3 6.8h-.1l-10-4.1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#id-0a)",
  d: "M126.4 59.4c0 11.1-9 20.1-20.1 20.1s-20.1-9-20.1-20.1c0-11.1 9-20.1 20.1-20.1 11.1 0 20 9 20.1 20.1zm-5 0c0-8.3-6.8-15.1-15.1-15.1s-15.1 6.8-15.1 15.1 6.8 15.1 15.1 15.1 15.1-6.8 15.1-15.1zm-81 57.9c3 6.3 9.5 9.9 16.1 9.6 2.2-.1 4.4-.6 6.5-1.7 8.5-4.1 12-14.2 8-22.7-2.9-6-8.8-9.6-15.1-9.6-2.1 0-4.2.3-6.3 1.1l10.2 4.2c6.4 2.6 9.4 10 6.8 16.3-2 4.8-6.6 7.7-11.5 7.7-1.6 0-3.3-.3-4.9-.9h-.1l-9.7-4zM.3 73.6zM80 0C38 0 3.5 32.4.3 73.6L43 91.3c3.8-2.6 8.2-3.9 12.7-3.9H57l19.1-27.6v-.4c0-16.7 13.5-30.2 30.2-30.2s30.2 13.5 30.2 30.2-13.5 30.2-30.2 30.2h-.7L78.4 109v1.1c0 10.8-7.6 20.1-18.2 22.2-1.5.3-3.1.5-4.6.4-10.5 0-19.9-7.5-22.1-18.2L3.1 101.9C12.6 135.4 43.4 160 80 160c44.2 0 80-35.8 80-80S124.2 0 80 0z"
})));

export default SvgSteam;